module.exports = authConfig;